// extracted by mini-css-extract-plugin
export var divider = "_ma-0";
export var systemMessage = "_ma-1";
export var systemMessageWrapper = "_ma-2";